module.exports = __webpack_public_path__ + "img/2.573cecb4.jpg";